import { Alert, Tooltip, message } from "antd"
import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import styled from "styled-components"

import BottomSheet from "../../../../../_shared/components/BottomSheet"
import AppInput from "../../../../../_shared/components/FormItems/AppInput"
import AppHeading from "../../../../../_shared/components/Typography/Heading"
import HtmlEditor from "../../../../../_shared/components/WYSIWYGEditor"
import { copyTextToClipboard } from "../../../../../_shared/toolkit/copyToClipboard"

// ----------------------------------------------------------------------------

function _EmailTemplatesBottomSheet(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, defaultValues, open, onCancel, onConfirm } = props
    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const [form, setForm] = useState({})

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        if (open && defaultValues) {
            setForm(defaultValues)
        } else if (!open) {
            setForm({})
        }
        // eslint-disable-next-line
    }, [open, defaultValues])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleSubmit() {
        onConfirm?.(form)
    }

    function updateForm(field) {
        return function (value) {
            setForm((prev) => {
                return {
                    ...prev,
                    [field]: value?.target?.value ? value.target.value : value,
                }
            })
        }
    }

    function renderInfoContent() {
        return (
            <div className="placeholder-info-content">
                <p>
                    Per questo template sono disponibili i seguenti placeholder,
                    utlizzabili sia nel soggetto che nel testo:
                </p>
                <ul>
                    {defaultValues?.placeholders?.map((p) => {
                        const { placeholder, description } = p
                        return (
                            <li key={placeholder}>
                                <Tooltip title="Clicca per copiare">
                                    <button
                                        type="default"
                                        onClick={() =>
                                            copyTextToClipboard(
                                                placeholder
                                            ).then(() =>
                                                message.success("Testo copiato")
                                            )
                                        }
                                        htmlType="button"
                                        className="placeholder"
                                    >
                                        {placeholder}
                                    </button>
                                </Tooltip>
                                {/* <span className="sep"> - </span> */}
                                <span className="description">
                                    {description}
                                </span>
                            </li>
                        )
                    })}
                </ul>
            </div>
        )
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <BottomSheet
            onConfirm={handleSubmit}
            onCancel={onCancel}
            title={defaultValues?.id ? "Modifica template" : "Crea template"}
            open={open}
            className={`${className}`}
            snapPoint={80}
        >
            {
                <>
                    <Alert
                        className="placeholder-info"
                        type="info"
                        message={renderInfoContent()}
                    />
                    <AppHeading className="heading" boldness="bold">
                        Oggetto
                    </AppHeading>
                    <AppInput
                        className="field"
                        value={form?.subject}
                        onChange={updateForm("subject")}
                    />
                    <AppHeading className="heading" boldness="bold">
                        Testo
                    </AppHeading>
                    <HtmlEditor
                        className="field editor"
                        value={form?.body}
                        onChange={updateForm("body")}
                        useValueField
                    />
                </>
            }
        </BottomSheet>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_EmailTemplatesBottomSheet.propTypes = {
    className: PropTypes.string.isRequired,
    defaultValues: PropTypes.object,
    open: PropTypes.bool,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
}

_EmailTemplatesBottomSheet.defaultProps = {}

// ----------------------------------------------------------------------------

const EmailTemplatesBottomSheet = styled(_EmailTemplatesBottomSheet)`
    & {
        .placeholder-info {
            margin-bottom: 20px;
            .placeholder-info-content {
                .placeholder {
                    border: none;
                    padding: 0;
                    background: transparent;
                    cursor: pointer;
                    width: 250px;
                    text-align: left;

                    &:hover {
                        text-decoration: underline;
                    }
                }
                .sep {
                }
                .description {
                    margin-left: 10px;
                }
            }
        }
        .field {
            margin-bottom: 20px;
            max-width: 400px;
            &.editor {
                max-width: 100%;
            }
        }
    }
`
// ----------------------------------------------------------------------------

export default EmailTemplatesBottomSheet
